module.exports = __webpack_public_path__ + "static/img/1.3624b72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R14/1.jpg
// module id = 7KLA
// module chunks = 1